import type { UA } from 'jssip';

let messageHandler: ((event: any) => void) | null = null;

export function setupSipMessageHandler(ua: UA | null, handleEvent: (eventName: string, data: any, props?: any) => void) {
  if (!ua || !handleEvent) {
    console.warn('Missing required parameters in setupSipMessageHandler');
    return;
  }

  // Clean up existing handler first
  cleanupSipMessageHandler(ua);

  try {
    // Create message handler function
    messageHandler = (event: { data?: { text?: string }; request?: { body?: string }; handled?: boolean }) => {
      try {
        // Prevent duplicate handling
        if (event.handled) {
          console.log('Event already handled, skipping');
          return;
        }
        event.handled = true;

        if (event.data && event.data.text) {
          handleEvent(event.data.text, event.data);
        } else if (event.request && event.request.body) {
          try {
            let body = JSON.parse(event.request.body);
            if (body.eventName === 'camlin.runtime.voice.tts.viseme') {
              handleEvent(body.eventName + '.webrtc', body);
            } else {
              handleEvent(body.eventName, body);
            }
          } catch (e) {
            console.error('Error parsing message body:', e);
          }
        }
      } catch (error) {
        console.error('Error handling SIP message:', error);
      }
    };

    // Register the handler
    ua.on('newMessage', messageHandler);
    console.log('SIP message handler registered');

  } catch (error) {
    console.error('Error setting up message handler:', error);
    messageHandler = null;
  }
}

export function cleanupSipMessageHandler(ua: UA | null) {
  if (!ua) {
    console.warn('No UA provided to cleanupSipMessageHandler');
    return;
  }

  try {
    if (messageHandler) {
      ua.removeListener('newMessage', messageHandler);
      console.log('SIP message handler removed');
    }
    messageHandler = null;
  } catch (error) {
    console.error('Error cleaning up message handler:', error);
  }
}
